<!-- 心理风险 -->
<template>
    <div class="page_part4">
        <div class="page_shadow page_main">
            <TopHeader :title="'心理风险评估结果'" :headerLogo="headerLogo"></TopHeader>
            <h5 class="header page_header">
                <span>Part.5 心理风险</span>
            </h5>
            <h6 class="page_title_2">
                <span>心理风险</span>
                <span class="arrow"></span>
            </h6>
            <div class="header_detail_box">
                <p class="header_detail">在下表中心理风险水平值是测试个体在各项心理指标中的水平高低，值越高则在该因子上测试者的症状越明显。</p>
                <p class="header_detail">常模范围是群体中大多数人在该项上的水平范围，图中评估的心理风险水平值高于常模范围，则说明在该指标上异常；若心理风险水平值在常模范围之内或低于常模范围，则说明该心理指标与大多数人无明显差别且正常。</p>
            </div>

            <p class="page_title_3">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                心理风险评估结果
            </p>
            <div class="table_box">
                <table>
                    <thead>
                    <tr>
                        <th rowspan="2">心理风险</th>
                        <th rowspan="2">心理风险水平值</th>
                        <th rowspan="2">常模范围</th>
                        <th colspan="5">得分</th>
                    </tr>
                    <tr>
                        <th width="64">1</th>
                        <th width="64">2</th>
                        <th width="64">3</th>
                        <th width="64">4</th>
                        <th width="64">5</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr  v-for="(value, index) in normSort" :key="index">
                        <td>{{value.name}}</td>
                        <td>{{value.score | toFixed(1)}}</td>
                        <td>{{normDataMind[value.type].l_norm}}~{{normDataMind[value.type].r_norm}}</td>
                        <td colspan="5">
                            <div class="line_box">
                                <div :class="['line_score', getBgColor(value.name,value.score)]" :style="{ width: value.score/5*324 + 'px' }" :title="value.score | toFixed(2)"></div>
                                <div class="lien_norm" :style="{left: normDataMind[value.type].l_norm/5*324 + 'px', width: ( normDataMind[value.type].r_norm - normDataMind[value.type].l_norm)/5*324 + 'px' }"></div>
                            </div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main" v-if="norm">
            <TopHeader :title="'心理风险分析'" :headerLogo="headerLogo"></TopHeader>
            <p class="page_title_3">
                <img src="~@/assets/report2_imgs/icon_fc.png" alt="">
                心理风险分析
            </p>
            <!-- 强迫症状、人际关系敏感、抑郁 -->
            <ThePart4Main :index="'1'" :normData="normDataMind.qiangpo"  :normObj="norm.qiangpo" :comment="comment.qiangpo" canvasId="canvas_qiangpo"></ThePart4Main>
            <ThePart4Main  :index="'2'" :normData="normDataMind.mingan" :normObj="norm.mingan" :comment="comment.mingan" canvasId="canvas_mingan"></ThePart4Main>
            <ThePart4Main :index="'3'" :normData="normDataMind.yiyu"  :normObj="norm.yiyu" :comment="comment.yiyu" canvasId="canvas_yiyu"></ThePart4Main>
            <p class="big_page_number"></p>
        </div>
        <div class="page_shadow page_main" v-if="norm">
            <TopHeader :title="'心理风险分析'" :headerLogo="headerLogo"></TopHeader>
            <!-- 焦虑、敌对、偏执 -->
            <ThePart4Main  :index="'4'" :normData="normDataMind.jiaolv"  :normObj="norm.jiaolv" :comment="comment.jiaolv" canvasId="canvas_jiaolv"></ThePart4Main>
            <ThePart4Main :index="'5'" :normData="normDataMind.didui"  :normObj="norm.didui" :comment="comment.didui" canvasId="canvas_didui"></ThePart4Main>
            <ThePart4Main  :index="'6'" :normData="normDataMind.pizhi"  :normObj="norm.pizhi" :comment="comment.pizhi" canvasId="canvas_pizhi"></ThePart4Main>
            <p class="big_page_number"></p>
        </div>
    </div>
</template>
<script>
import TopHeader from './TopHeader.vue';//页眉
import ThePart4Main from './ThePart4Main.vue';//目录
export default {
    name: 'page_part4',
    components: { TopHeader,ThePart4Main },
    props: {
        headerLogo:{},
        normDataMind: {},
        norm: {
            type: Object,//norm数组的其中一项
            // required: true
        },
        comment: {
            type: Object,//comment的类型解读
            // required: true
        },
        partIndex: {
            type: Number
        }
    },
    data() {
        return {
            // comment: null,
            // norm: null,
        }
    },
    computed: {
        normSort() {
            let arr = [];
            let norm = this.norm;
            arr[0] = norm.qiangpo;
            arr[1] = norm.mingan;
            arr[2] = norm.yiyu;
            arr[3] = norm.jiaolv;
            arr[4] = norm.didui;
            arr[5] = norm.pizhi;
            return arr;
        }
    },
    watch: {
    },
    created() {
        // this.getXljkInfo()
    },
    mounted() {
    },
    methods: {
        getColor(value) {
            if(value < 1) {
                return 'c_line_score1';
            }else if(value < 2) {
                return 'c_line_score2';
            }else if(value < 3) {
                return 'c_line_score3';
            }else if(value < 4) {
                return 'c_line_score4';
            }else {
                return 'c_line_score5';
            }
        },
        getBgColor(name,value) {
            let normObj = {
                qiangpo: [0,1.38,2.82,3,4,5],
                renji: [0,1.04,2.5,3,4,5],
                yiyu: [0,1.06,2.48,3,4,5],
                jiaolv: [0,1.06,2.44,3,4,5],
                didui: [0,1.07,2.55,3,4,5],
                pianzhi: [0,1.06,2.42,3,4,5]
            }
            let normArr;
            if(name == '强迫症状') {
                normArr = normObj.qiangpo;
            }else if(name == '人际关系敏感') {
                normArr = normObj.renji;
            }else if(name == '抑郁') {
                normArr = normObj.yiyu;
            }else if(name == '焦虑') {
                normArr = normObj.jiaolv;
            }else if(name == '敌对') {
                normArr = normObj.didui;
            }else if(name == '偏执') {
                normArr = normObj.pianzhi;
            }

            if(normArr[0]<value&&value<normArr[1]) {
                return 'c_mind1'
            }else if (normArr[1]<=value&&value<normArr[2]){
                return 'c_mind2'
            }else if (normArr[2]<=value&&value<normArr[3]){
                return 'c_mind3'
            }else if (normArr[3]<=value&&value<normArr[4]){
                return 'c_mind4'
            }else{
                return 'c_mind5'
            }
        },
    }
}
</script>
<style type="text/css" lang='less' scoped>
@import './report.less';
.page_part4 {
    .table_box {
        padding-bottom: 60px;
        tr {
            .c_line_score1 {
                background-color: #00B050;
            }
            .c_line_score2 {
                background-color: #92D050;
            }
            .c_line_score3 {
                background-color: #01B0F0;
            }
            .c_line_score4 {
                background-color: #FFC001;
            }
            .c_line_score5 {
                background-color: #FF0000;
            }
            th {
                color: #fff;
                font-size: 16px;
                line-height: 42px;
                background-color: #F6A724;
                border: 1px solid #fff;
                text-align: center;
            }
            td {
                font-size: 14px;
                height: 60px;
                text-align: center;
                background-color: #F7F7F7;
                border: 1px solid #fff;
                .line_box {
                    height: 20px;
                    position: relative;
                    .line_score {
                        height: 20px;
                    }
                    .lien_norm {
                        position: absolute;
                        top: 0px;
                        height: 20px;
                        background: rgba(121, 119, 119, 0.55);
                        //opacity: 0.59;
                    }
                }

            }
        }
    }
}
</style>
